export default __webpack_public_path__ + "static/financialTarget-d6a87f12c49945ed16378fb84b481e5f.svg";